<template>
    <div>
        <div class="px-3 py-2">
            <b-sidebar aria-labelledby="sidebar-no-header-title" width="700px" no-header id="import_file" backdrop style="direction:ltr" right :title="lang.add_new_account" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:140px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span style="font-size:.8em;">استيراد</span>
                        </div>
                        <div @click="hide" id="dhideExp" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{lang.close}}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="px-3 py-2" :style="`direction:`+lang.dir">
                        <v-row>
                            <v-col cols="8">
                                <b-form-file class="inborder" type="file" v-model="fileit" @change="handleFileUpload" />
                            </v-col>
                            <v-col cols="4">
                                <button @click="downloadSamle()">تحميل نموذج الاكسل</button>
                                <button v-if="type == 10" @click="downloadErpSample()" style="margin-top:6px;">تحميل نموذج حقول النظام</button>
                            </v-col>
                        </v-row>
                    </div>
                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                        <b-button type="button" variant="success" @click="uploadFile()" class="ma-2" style="width:100px;">استيراد</b-button>
                    </div>
                </template>
            </b-sidebar>

        </div>
    </div>
</template>

<script>
/* global XLSX */
import axios from 'axios';
export default {
    data() {
        return {
            /**
             * Must match `samples` below and the $this->type branches in
             * php/includes/classes/class.import.php:
             * 1 chart of accounts, 2 journal entries, 3 opening balance,
             * 4 outgoing voucher, 5 incoming voucher, 6 purchase,
             * 7 invoices, 8 customers, 9 expenses, 10 inventory products (items)
             * */
            type: 1,
            /**
             * 1: add new without affect others and can be modify others
             * 2: truncate tables and create new from scratch
             */
            uploadMethod: 1,
            selectedFile: null,
            fileit: null,

        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        samples: function () {
            return [
                [],
                [ // chart of account 1
                    [
                        'account #', 'account name arabic', 'account name en', 'parent #', 'account type (main/details)',
                        'account value (debit/credit)', 'report type (balance sheet/ income statement)', 'integrated'
                    ]
                ],
                [ // jentry 2
                    [
                        'date', 'jv #', 'account number' , 'debit', 'credit', "notes",
                        "cost center name (will be added if not exist)",
                        "overall note", "jentry type(customers, vendors, employee, fixed assets, or empty)",
                        "item id (ex. if customer go to customer list and get its id)",
                        "item name (ex. if customer customer name)",
                        "item vatid (ex. if customer or vendor add its vatid)",
                        "item crt number (like vatid)"
                    ],
                ],
                [ // open balance 3
                    [
                        'date', 'jv #', 'account number' , 'debit', 'credit', "notes",
                        "cost center name (will be added if not exist)",
                        "overall note", "jentry type(customers, vendors, employee, fixed assets, or empty)",
                        "item id (ex. if customer go to customer list and get its id)",
                        "item name (ex. if customer customer name)",
                        "item vatid (ex. if customer or vendor add its vatid)",
                        "item crt number (like vatid)"
                    ],
                ],
                [ // in come voutcher 4
                    [
                        'date', 'voutcher type (customers, vendors, employees, invoice, job_card, others)',
                        'mobile (for customer, for vendor use same mobile in their accounts, and if employee his mobile, or others any mobile )',
                        'full name', 'amount', 'pay type (use same name in payment types)', 'account number', 'voutcher notes'
                    ],
                ],
                [ // expence voutcher 5
                    [
                        'date', 'voutcher type (customers, vendors, employees, invoice, job_card, others)',
                        'mobile (for customer, for vendor use same mobile in their accounts, and if employee his mobile, or others any mobile )',
                        'full name', 'amount', 'pay type (use same name in payment types)', 'account number', 'voutcher notes'
                    ],
                ],
                [ // purchase 6
                    [
                        'date', 'invoice number',
                        'vendor mobile', 'vendor name', 'vendor vat id', 'vendor address',
                        'invoice type (1 for cash, 2 for credit)', 'item number', 'item name',
                        'item price', 'discount', 'quantity', 'total ex. of vat', 'vat amount', 'total in. vat',
                        'pay type (use same name in payment types)', 'نوع الفاتورة (للمشتريات 1 او 2 اصول ثاتبة)'
                    ],
                ],
                [ // invoices 7
                    [
                        'date', 'invoice number',
                        'item id', 'item name', 'item unit (use 1 for piece)',
                        'customer mobile', 'customer name', 'customer type (1 for indivisual, 2 for company, 3 for government)',
                        'company name', 'address', 'vat number' , 'crt number', 'entity name', 'branch name',
                        'invoice type (1 for cash, 2 for credit)', 'pay type (use same name in payment types)',
                        'item price', 'discount', 'quantity', 'total ex. of vat', 'vat amount', 'total in. vat', 'notes',
                        "plate number", "car brand", "car name" , "car model" , "car color" , "car VIN", "car engin meter", "item type (1 spare part, 2 service)"
                    ],
                ],
                [ // customers 8
                    [
                        'customer mobile', 'customer name', 'customer type (1 for indivisual, 2 for company, 3 for government)',
                        'company name', 'address', 'vat number' , 'crt number', 'building number', 'street name', 'branch number',
                        'district', 'zip code'
                    ],
                ],
                [ // expenses 9
                    [
                        'date', 'invoice number',
                        'vendor mobile', 'vendor name', 'vendor vat id', 'vendor address',
                        'invoice type (1 for cash, 2 for credit)', 'item name',
                        'item price', 'discount', 'quantity', 'total ex. of vat', 'vat amount', 'total in. vat',
                        'pay type (use same name in payment types)',
                    ],
                ],
                [ // inventory products 10
                    [
                        'No.', 'النوع', 'أسم المنتج', 'تصنيف المنتج', 'صورة المنتج',
                        'وصف صورة المنتج', 'نوع المنتج', 'سعر المنتج', 'الكمية المتوفرة',
                        'الوصف', 'هل يتطلب شحن؟', 'رمز المنتج sku', 'سعر التكلفة',
                        'السعر المخفض', 'تاريخ بداية التخفيض', 'تاريخ نهاية التخفيض',
                        'اقصي كمية لكل عميل', 'إخفاء خيار تحديد الكمية',
                        'اضافة صورة عند الطلب', 'الوزن', 'وحدة الوزن', 'حالة المنتج',
                        'الماركة', 'العنوان الترويجي', 'تثبيت المنتج', 'الباركود',
                        'السعرات الحرارية', 'MPN', 'GTIN', 'خاضع للضريبة ؟',
                        'سبب عدم الخضوع للضريبة', 'غير محدود الكمية',
                        'عنوان صفحة المنتج', 'وصف صفحة المنتج', 'رابط مخصص للمنتج',
                        '[1] القيمة'
                    ],
                ]
            ];
        },
        // Columns named after the product fields themselves. The items importer matches
        // headers by name and accepts either this or the webstore export layout, so a
        // sheet built from this template lands directly on inventory_products.
        erpItemsSample: function () {
            return [
                [
                    'كود الصنف', 'الاسم بالعربي', 'الاسم بالانجليزي', 'التصنيف', 'الوحدة',
                    'السعر', 'التكلفة', 'الكمية', 'باركود', 'MPN', 'GTIN',
                    'العلامة التجارية', 'كود المورد', 'الكود الداخلي',
                    'خاضع للضريبة', 'قابل للإرجاع', 'الوصف'
                ]
            ];
        },
        uploadMethods: function(){
            return [
                {text: this.lang.add_new_row, value: 1},
                {text: this.lang.delete_old, value: 2},
            ]
        }
    },
    methods: {
        downloadSamle() {
            const ws = XLSX.utils.aoa_to_sheet(this.samples[this.type] || [[]]);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
            XLSX.writeFile(wb, "file sample.xlsx");
        },

        downloadErpSample() {
            const ws = XLSX.utils.aoa_to_sheet(this.erpItemsSample);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
            XLSX.writeFile(wb, "items sample.xlsx");
        },

        handleFileUpload(event) {
            const file = (event && event.target && event.target.files) ? event.target.files[0] : null;
            if (!file) {
                this.selectedFile = null;
                return;
            }

            // Browsers report .xlsx as octet-stream (or as nothing) often enough that the
            // MIME list alone rejected valid files; the extension is the reliable check.
            const name = (file.name || '').toLowerCase();
            if (!name.endsWith('.xlsx') && !name.endsWith('.xls')) {
                alert("Please upload a valid Excel file (.xls or .xlsx).");
                this.selectedFile = null;
                return;
            }

            this.selectedFile = file;
        },
        async uploadFile() {

            if (!this.selectedFile) {
                alert("No file selected.");
                return;
            }

            const post = new FormData();

            post.append('type',"importExcelFile");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[file]',this.selectedFile);
            post.append('data[type]',this.type);
            post.append('data[uploadMethod]',this.uploadMethod);
            try {
                const response = await axios.post(this.$store.state.SAMCOTEC.r_path , post, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                const body = response.data;

                // A PHP fatal or a warning printed before the JSON leaves us with a
                // string here. That used to fall through every branch, so a failed
                // import looked exactly like doing nothing at all.
                if(!body || typeof body !== 'object' || !body.error){
                    console.error("Import: unexpected response", body);
                    alert("Import failed: the server did not return a valid response. Check the API error log.");
                    return;
                }

                const results = (body.results && body.results.data) ? body.results.data : {};
                const rowErrors = Array.isArray(results.errors) ? results.errors : [];
                const summary = results.summary || {};
                const importedCount = Array.isArray(results.imported) ? results.imported.length : 0;

                if(body.error.number === 200){
                    let message = `تم الاستيراد بنجاح (${importedCount})`;
                    if(summary && typeof summary.processed !== 'undefined'){
                        message += `\n${JSON.stringify(summary)}`;
                    }
                    alert(message);
                    this.fileit = null;
                    this.selectedFile = null;
                    this.$emit('imported', body.results);
                    return;
                }

                // Anything else: show what actually went wrong, including the per-row
                // errors the backend already collects but nobody was reading.
                let message = body.error.message || 'Import failed.';
                if(rowErrors.length){
                    message += '\n\n' + rowErrors.slice(0, 10)
                        .map((e) => `${e.context}: ${e.message}`).join('\n');
                    if(rowErrors.length > 10){
                        message += `\n... +${rowErrors.length - 10}`;
                    }
                }
                alert(message);
                if(importedCount > 0){
                    this.$emit('imported', body.results);
                }
            } catch (error) {
                console.error("Upload failed:", error);
                const serverMessage = error && error.response && error.response.data
                    && error.response.data.error && error.response.data.error.message;
                alert(serverMessage || `Import failed: ${error.message || error}`);
            }
        },
    },
    created() {
        //
    }
}
</script>
